import { FC, } from "react";

import RadarChart from "../RadarChart";
import { EvaluationChartData } from "../../../core/_models";

interface Props {
    data: EvaluationChartData | null
    chartheight?: number
}

const principles = [
    { title: "Principle 1", key: "chart_data_p1", suffix: "p1" },
    { title: "Principle 2", key: "chart_data_p2", suffix: "p2" },
    { title: "Principle 3", key: "chart_data_p3", suffix: "p3" },
    { title: "Principle 4", key: "chart_data_p4", suffix: "p4" },
];

const PanopticEvaluatorModal: FC<Props> = ({
    data,
    chartheight = 250
}) => {
    return (
        <div className="d-flex flex-column position-relative">
            <div className="row">
                {principles.map((p, index) => (
                    <div className="col-12 col-sm-6 col-md-3">
                        <h5 className="apple-title fs-3 mb-0 d-flex justify-content-center">
                            <span className="d-flex align-items-center rounded-4 px-6">
                                {p.title}
                            </span>
                        </h5>
                        <div>
                            <RadarChart
                                chart_data={data ? (data as any)[p.key] : []}
                                chartSuffix={`panoptic-principle-${p.suffix}`}
                                chartHeight={chartheight}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
};

export default PanopticEvaluatorModal;